import { FilterState } from './reducer'
import { useRouter } from 'next/router'
import * as qs from 'query-string'
import { useEffect, useRef } from 'react'

export function useUrlSync(state: FilterState) {
  const router = useRouter()
  const isMounted = useRef(false)
  const { country, opened, services, brands } = state
  let query = {
    country,
    opened,
    services,
    brands,
  }

  useEffect(() => {
    if (!isMounted.current) {
      return
    }
    const params = qs.stringify(query, { arrayFormat: 'comma' })
    const currentUrl = `${window.location.host}${window.location.search}`
    const newUrl = `${window.location.host}?${params}`

    if (newUrl !== currentUrl) {
      router.replace(
        router.pathname,
        `${window.location.pathname}${params.length ? `?${params}` : ''}`,
        { shallow: true },
      )
    }
  }, [country, opened, services, brands]) // eslint-disable-line

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
    }
  }, [])
}
